import { useState, useEffect, useRef } from "react";
import { getPromoBar } from "../../api/promoBar";
import { Bar, Track, Item } from "./PromoBar.styles";

export default function PromoBar({ onHeight }) {
  const [text, setText] = useState(null);
  const [speed, setSpeed] = useState(5);
  const barRef = useRef(null);

  useEffect(() => {
    getPromoBar()
      .then((data) => {
        if (data?.isActive && data?.text) {
          setText(data.text);
          setSpeed(data.speed ?? 5);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (text && barRef.current) {
      onHeight?.(barRef.current.offsetHeight);
    } else {
      onHeight?.(0);
    }
  }, [text, onHeight]);

  if (!text) return null;

  const repeats = Array.from({ length: 8 }, (_, i) => i);
  const duration = 70 - speed * 6; // speed 1=64s, 5=40s, 10=10s

  return (
    <Bar ref={barRef}>
      <Track $duration={duration}>
        {repeats.map((i) => (
          <Item key={i}>{text}</Item>
        ))}
      </Track>
    </Bar>
  );
}
